import { VFC } from 'react'
import { trueblack, truewhite, _profilegreen } from 'src/styles/colors'
import styled from 'styled-components'
import { inversing } from '../../styles/mixins'
type FilterCreatePopUpMenuProps = {
  close: VoidFunction
  submit: VoidFunction
}
export const FilterCreatePopUpMenu: VFC<FilterCreatePopUpMenuProps> = ({
  close,
  submit,
}) => {
  return (
    <>
      <FilterCreatePopUpMenuDiv>
        <Layout>
          <FilterParamButton>
            <Message>現在の絞り込み条件でフィルタを作成できます</Message>
            <CancelButton onClick={close}>キャンセル</CancelButton>
            <FilterSettingButton onClick={submit}>
              フィルタを作成
            </FilterSettingButton>
          </FilterParamButton>
        </Layout>
      </FilterCreatePopUpMenuDiv>
    </>
  )
}

const FilterCreatePopUpMenuDiv = styled.div`
  position: fixed;
  bottom: 14px;
  right: 26px;
  background: ${truewhite};
`

const Layout = styled.div`
  z-index: 1;
  box-shadow: 0 5px 15px ${trueblack}80;
  padding: 32px;
`

const Message = styled.div`
  font-size: 16px;
  font-weight: 700;
`

const FilterParamButton = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: baseline;
`

const CancelButton = styled.button`
  display: block;
  color: ${_profilegreen};
  border-radius: 5px;
  margin-left: 37px;
  text-align: center;
  color: #808080;
`

const FilterSettingButton = styled.button`
  display: block;
  color: ${truewhite};
  width: 146px;
  padding: 8px 0;
  margin-left: 37px;
  border-radius: 5px;
  border: solid ${_profilegreen} 1px;
  text-align: center;
  background: ${_profilegreen};

  ${inversing({ color: truewhite, background: _profilegreen })};

  @media screen and (max-width: 540px) {
    margin-left: 0px;
  }
`
